import { render, staticRenderFns } from "./printTpl.vue?vue&type=template&id=2028f6d6&scoped=true&"
import script from "./printTpl.vue?vue&type=script&lang=js&"
export * from "./printTpl.vue?vue&type=script&lang=js&"
import style0 from "./printTpl.vue?vue&type=style&index=0&id=2028f6d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2028f6d6",
  null
  
)

export default component.exports